import React from 'react';

/**
 * ConsentCheckbox - custom-styled native HTML checkbox for long, multi-line
 * consent labels. Uses padding-left on the label span (rather than flex/grid
 * gap) to guarantee spacing between checkbox and text — margin/gap can be
 * eaten by CSS resets, but padding is unambiguous.
 *
 * Props: label, checked, onChange, error, disabled, bold
 */

const CHECK_SVG = encodeURIComponent(
  `<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 10'>
    <path d='M1 5.5L4.5 9L11 1.5' stroke='white' stroke-width='1.5' fill='none' stroke-linecap='round' stroke-linejoin='round'/>
  </svg>`
);

const ConsentCheckbox = ({
  label,
  checked,
  onChange,
  error,
  disabled = false,
  bold = false
}) => {
  const cursor = disabled ? 'default' : 'pointer';
  const isChecked = !!checked;

  return (
    <div>
      <label
        style={{
          display: 'flex',
          alignItems: 'flex-start',
          cursor,
          opacity: disabled ? 0.6 : 1
        }}
      >
        <input
          type="checkbox"
          checked={isChecked}
          onChange={onChange}
          disabled={disabled}
          style={{
            appearance: 'none',
            WebkitAppearance: 'none',
            MozAppearance: 'none',
            width: 18,
            height: 18,
            minWidth: 18,
            minHeight: 18,
            flexShrink: 0,
            margin: 0,
            marginTop: 4,
            padding: 0,
            border: `1.5px solid ${isChecked ? 'var(--primary-gold)' : '#c9c9c9'}`,
            borderRadius: 4,
            background: isChecked ? 'var(--primary-gold)' : 'white',
            backgroundImage: isChecked ? `url("data:image/svg+xml,${CHECK_SVG}")` : 'none',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            backgroundSize: '9px 7px',
            boxShadow: 'none',
            WebkitBoxShadow: 'none',
            outline: 'none',
            cursor,
            transition: 'background-color 0.15s ease, border-color 0.15s ease',
            display: 'block'
          }}
        />
        <span
          style={{
            paddingLeft: 14,
            lineHeight: 1.5,
            fontWeight: bold ? 500 : 400,
            color: 'var(--charcoal)',
            textAlign: 'left'
          }}
        >
          {label}
        </span>
      </label>
      {error && (
        <div
          style={{
            color: '#fa5252',
            fontSize: '0.75rem',
            marginTop: 4,
            marginLeft: 36,
            textAlign: 'left'
          }}
        >
          {typeof error === 'string' ? error : 'Required'}
        </div>
      )}
    </div>
  );
};

export default ConsentCheckbox;
